// extracted by mini-css-extract-plugin
module.exports = {"root":"DashedLine_root__5v756"};